import { FeatureMarker } from '@as/cotopaxi';
import { isNullOrUndefined, mergeProductPricesToProductLister } from '@as-react/common-utils';
export const getCompareProductPriceInformation = (product) => {
    var _a, _b, _c;
    const activeColour = product.colours.find(colour => colour.colourId === product.colourId);
    const selectedSku = ((_a = product.deliveryPromise) === null || _a === void 0 ? void 0 : _a.skuId.toString()) || product.selectedSku;
    if (selectedSku) {
        const selectedSize = activeColour === null || activeColour === void 0 ? void 0 : activeColour.sizes.find(size => size.sku === selectedSku);
        if ((_b = selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.prices) === null || _b === void 0 ? void 0 : _b.SELL) {
            return {
                prices: selectedSize.prices,
                hasDiscount: Boolean(activeColour === null || activeColour === void 0 ? void 0 : activeColour.hasDiscount),
            };
        }
    }
    else if ((_c = activeColour === null || activeColour === void 0 ? void 0 : activeColour.prices) === null || _c === void 0 ? void 0 : _c.SELL) {
        return {
            prices: activeColour.prices,
            hasDiscount: activeColour.hasDiscount,
        };
    }
    return null;
};
export const getAttributesForProducts = (productsWithAttributes, productsOutOfStock) => !productsWithAttributes.titles
    ? []
    : productsWithAttributes.titles.map((item) => {
        var _a;
        const resultObj = {
            attribute: item.attribute,
            title: item.title,
            valuesByProducts: [],
        };
        (_a = productsWithAttributes.items) === null || _a === void 0 ? void 0 : _a.forEach((product, index) => {
            var _a, _b;
            const attributeValue = product.features[item.attribute];
            if (productsOutOfStock[index]) {
                resultObj.valuesByProducts.push(FeatureMarker.OUT_OF_STOCK);
            }
            else if (!isNullOrUndefined(attributeValue)) {
                const attributeType = (_b = (_a = product.featureList) === null || _a === void 0 ? void 0 : _a.find(feature => feature.featureName === item.attribute)) === null || _b === void 0 ? void 0 : _b.featureType;
                resultObj.valuesByProducts.push(attributeType === 'BOOLEAN' && attributeValue === '1'
                    ? Boolean(attributeValue).toString()
                    : attributeValue);
            }
            else {
                resultObj.valuesByProducts.push(null);
            }
        });
        return resultObj;
    });
export const getComparisonProducts = (products, productsPrices) => products.map((product) => {
    const productPrice = productsPrices.find(tmpProductPrice => product.productId === tmpProductPrice.productId);
    return mergeProductPricesToProductLister(product, productPrice);
});
